import { createApp } from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import VueGoogleMaps from '@fawmi/vue-google-maps'
import router from './router'
import metaManager from './plugins/meta'
import VueGtag from 'vue-gtag'

loadFonts()

const app = createApp(App)

app.use(vuetify)
  .use(router)
  .use(metaManager)
  .use(VueGtag, {
    config: {
      id: 'G-KKXDES07H9',
      additional_config: {
        'AW-1002935987': { send_page_view: true }
      }
    },
    appName: 'RRamos Consultoria',
    pageTrackerScreenviewEnabled: true,
    bootstrap: true,
    enabled: true
  }, router)
  .use(VueGoogleMaps, {
    load: {
      key: 'AIzaSyCANU8Bkqe20HWiCRzqg8OJfeQbspArGtw',
      libraries: 'places',
      region: 'BR',
      language: 'pt-BR',
      async: true,
     },
    })
  .mount('#app')
